export const noChargeDwellingTypes = ['C', 'D', 'K', 'L', 'M', 'N', 'O', 'Q'];


// WEBPACK FOOTER //
// ./src/constants/dwellingTypes.js